const Particles = ({num=10, base=0, classNameCustom=''}) => {
  const cn = classNameCustom ? classNameCustom : 'particle';
  const particles = [];
  for(let i = 0; i < num; i++) {
    particles.push(<div className={cn + " p" + (i+1) + ((i < base) ? ' base' : ' random')} key={i+1}></div>);
  }

  return (
    <div className={cn+"s"}>
      <div className={cn+"s-wrapper"}>
        {particles}
      </div>
    </div>
  )
}

export default Particles;